import {Component, EventEmitter,OnInit,Injectable, Pipe, PipeTransform} from '@angular/core';
import {CommonService} from "../common.service";
import {Router} from "@angular/router";
import {MaterializeAction} from 'angular2-materialize/dist';

@Pipe({
    name: 'searchfilter'
})

export class SearchFilterPipe implements PipeTransform {
    transform(value: any, input: string): any[] {
       // console.log(input);
        if(value){
           // value = value.toLowerCase();
            return value.filter(function (el: any) {
                return el.name.toLowerCase().indexOf(input) > -1;
            })
        }
        return value;
    }
}

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
    searchName : any;
    showIndivisualReport : boolean = false;
    modalActions = new EventEmitter<string|MaterializeAction>();
    showIndivisual2Report : boolean = false;
    indivisualReport : any;
    indivisual2ndReport : any;
    whatsMeans = new Array();
    whatsMeans2 = new Array();
    private facilitatorInfo;
    private campusInfo;
    private totalCampus: number = 0;
    masterApi ;
    facilitatorsMerge = [];
    Allfacilitators = [];
    private dimArr;
    private selected;
    constructor(public commonService: CommonService,private router: Router) {
        //console.log('dashboard')
    }

    ngOnInit() {
        let data = {
            'client': 1,
            'token': localStorage.getItem('token')
        }
        let url = 'http://node.illumine.info/zl61s7';
        this.commonService.post_data(data, url).subscribe(
            response => {
                console.log(response)
                //noinspection TypeScriptUnresolvedVariable
                if (response.status == 'success') {
                    console.log(response)
                    //noinspection TypeScriptUnresolvedVariable
                    this.commonService.setAuditInfo(response.data);
                    this.campusInfo = this.commonService.getAuditInfo();
                    this.campusInfo.forEach((value: any) => {
                        //console.log(value.facilitators);
                        this.totalCampus = this.totalCampus + value['facilitators'].length;

                    });
                    ///this.router.navigate(['facilitator-progress']);
                    var abc = this.campusInfo.map(x => {
                        return x.facilitators.map(y => {
                            //console.log(y.audits);
                            if(y.hasOwnProperty("audits")){
                                return {'name':y.name, 'audits':y.audits, 'audistLength':y.audits.length, 'lastAudits':y.audits[y.audits.length - 1].lastEditedOn};
                            }else{
                                return {'name':y.name, 'audits':'', 'audistLength':'', 'lastAudits':''};
                            }

                        });
                    });

                    for(let i = 0; i < abc.length; i++){
                        this.facilitatorsMerge = this.facilitatorsMerge.concat(abc[i]);
                        this.Allfacilitators.push(abc[i].sort(this.sort));
                    }

                   // console.log(this.facilitatorsMerge);
                    //console.log(this.Allfacilitators);
                    /**
                     * sort array
                     * @type {any}
                     */
                    this.facilitatorsMerge.sort(this.sort);
                    //console.log(this.facilitatorsMerge);
                    this.masterApi = this.commonService.getMasterApi();
                    //noinspection TypeScriptUnresolvedFunction
                    this.dimArr = Object.values(this.commonService.getMasterApi())
                    console.log(this.masterApi);
                    //delete this.dimArr["lang"]
                    this.dimArr.pop();
                     console.log(this.dimArr)
                } else {
                    localStorage.setItem('token', "");
                    localStorage.setItem('email', "");
                    location.reload();
                }
            }, error => {
                console.log(error);
            }
        );
    }

    sort(a, b) {
        if (a.lastAudits < b.lastAudits) {
            return 1;
        }
        if (a.lastAudits > b.lastAudits) {
            return -1;
        }
        if (a.lastAudits == b.lastAudits) {
            return 0;
        }
    }
    get_audit_report(facilitator) {
        console.log(facilitator);
        this.whatsMeans = [];
        if(facilitator.audits){
            //console.log(facilitator.audits[0].auditData)
            //console.log(facilitator);
            this.showIndivisualReport = true;
            this.indivisualReport = facilitator.audits[facilitator.audits.length - 1];
            //console.log(facilitator);
            this.indivisualReport['name'] = facilitator.name;
            this.indivisualReport['alength'] = facilitator.audits.length;
            console.log(facilitator);
            this.indivisualReport['facilitator'] = Object.assign({}, facilitator);
            var objectArr = facilitator.audits[facilitator.audits.length - 1].auditData;
            this.indivisualReport['rating'] = this.get_rating(facilitator.audits[facilitator.audits.length - 1].auditData);
            var i= 1;
            //console.log(this.indivisualReport);
            Object.keys(objectArr).forEach((key: any) => {
                let pushObj = {
                    'heading' : this.masterApi['datadim00'+i]['text'],
                    'text' : this.masterApi['datadim00'+i]['options'][objectArr[key]-1]['interpretation']['college'],
                    'image' : this.masterApi['datadim00'+i]['options'][objectArr[key]-1]['img']['selected'],
                    'auditor' :  this.indivisualReport['Comments'] ? this.indivisualReport['Comments']['dim00'+i]: '',
                }
                this.whatsMeans.push(pushObj);
                i++;
            });

        }else{
            this.showIndivisualReport = false;
        }
    }
    checkDate(auditDate){
        var date1 = new Date();
        var date2 = new Date(auditDate);
        var timeDiff = Math.abs(date2.getTime() - date1.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
       // console.log(diffDays);
        if(diffDays < 3){
            //console.log("if");
            return true;
        }else{
            //console.log("else");
            return false;
        }
    }
    back(){
        this.showIndivisualReport = false;
    }

    back2(){
        this.showIndivisualReport = true;
        this.showIndivisual2Report = false;
    }

    get_rating(audits){
        //console.log(audits);
        let arr = Array();
        let count : number = 0;
        for(let i = 1; i<=6; i++  ){
            if(audits['dim00'+i] == 1){
                arr['color'] = "red";
                arr['number'] = "!";
                return arr;
            }else{
                if(audits['dim00'+i] == 2){
                    count = count + 1;
                }
                if(audits['dim00'+i] == 3){
                    count = count + 3;
                }
            }
        }
        //console.log((count/1.8).toFixed(1));
        var numb = parseFloat((count/1.8).toFixed(1));
        if(numb == 10){
            arr['color'] = "green";
        }else{
            arr['color'] = "yellow";
        }
        arr['number'] = numb;
        return arr;
    }

    get_audit2nd_report(facilitator,index) {
        this.whatsMeans2 = [];
        console.log(facilitator.audits);
        if(facilitator.audits){
            this.showIndivisualReport = false;
            this.showIndivisual2Report = true;
            //console.log(facilitator.audits[0].auditData)
            console.log(facilitator);
            this.indivisual2ndReport = facilitator.audits[index];
            this.indivisual2ndReport['name'] = facilitator.name;
            //console.log(this.indivisual2ndReport);
            var objectArr = facilitator.audits[index].auditData;
            this.indivisual2ndReport['rating'] = this.get_rating(facilitator.audits[index].auditData);
            var i= 1;
            Object.keys(objectArr).forEach((key: any) => {
                let pushObj = {
                    'heading' : this.masterApi['datadim00'+i]['text'],
                    'text' : this.masterApi['datadim00'+i]['options'][objectArr[key]-1]['interpretation']['college'],
                    'image' : this.masterApi['datadim00'+i]['options'][objectArr[key]-1]['img']['selected'],
                    'auditor' :  this.indivisual2ndReport['Comments'] ? this.indivisual2ndReport['Comments']['dim00'+i]: '',
                }
                this.whatsMeans2.push(pushObj);
                i++;
            });

        }else{
            console.log("false");
            this.showIndivisual2Report = false;
        }
    }

    openModal() {
        this.modalActions.emit({action: "modal", params: ['open']});
    }

    closeModal() {
        this.modalActions.emit({action: "modal", params: ['close']});
    }

    showSelected(){
        this.selected = !this.selected;
    }
}



// WEBPACK FOOTER //
// /var/www/illumine/desktop/src/app/dashboard/dashboard.component.ts